// extracted by mini-css-extract-plugin
export default {"sectionHeader":"oWIDluATvRgqWZkZiBul__sectionHeader___","sectionTitle":"vQdhRAJMT7GI0i7TyS3l__sectionTitle___","sectionDescription":"_eL5RDy0abMpQ5zk0IVJ__sectionDescription___"};